import * as React from 'react';
import styled from 'styled-components';
import { DeliveryStep } from '../../ui/delivery/Step';

const StyledSectionContent = styled.div`
  display: none;
  @media all and (min-width: 1030px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

const DeliveryDescriptionItemsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  width: 100%;

  .line {
    position: relative;
    content: '';
    justify-self: center;
    display: inline-block;
    width: 2px;
    height: 50px;
    left: -30px;
    background: ${({ theme }) => theme.colors.primary};
  }

  @media all and (min-width: 1030px) {
    grid-template-columns: repeat(21, 1fr);
    .line {
      content: '';
      justify-self: auto;
      align-self: center;
      display: inline-block;
      width: auto;
      height: 2px;
      left: auto;
      background: ${({ theme }) => theme.colors.primary};
    }
  }

  .info {
    margin-top: 150px;
    display: block;

    h5 {
      margin-bottom: 10px;
    }
  }
`;

const DeliveryDescriptionWrapper: React.FC = () => {
  return (
    <DeliveryDescriptionItemsWrapper>
      <DeliveryStep
        label="1"
        infoLabel="Komme i gang"
        to="/leveransebeskrivelse-selge-bolig/komigang"
      />
      <div className="line" />
      <DeliveryStep
        label="2"
        infoLabel="Befaring"
        to="/leveransebeskrivelse-selge-bolig/befaring"
      />
      <div className="line" />
      <DeliveryStep
        label="3"
        infoLabel="Hvordan presentere eiendommen"
        to="/leveransebeskrivelse-selge-bolig/hvordan-presentere-boligen"
      />
      <div className="line" />
      <DeliveryStep
        label="4"
        infoLabel="Markedsføring"
        to="/leveransebeskrivelse-selge-bolig/markedsforing"
      />
      <div className="line" />
      <DeliveryStep
        label="5"
        infoLabel="Visning"
        to="/leveransebeskrivelse-selge-bolig/visning"
      />
      <div className="line" />
      <DeliveryStep
        label="6"
        infoLabel="KVADRAT"
        to="/leveransebeskrivelse-selge-bolig/kvadrat"
      />
      <div className="line" />
      <DeliveryStep
        label="7"
        infoLabel="Budrunde"
        to="/leveransebeskrivelse-selge-bolig/budrunde"
      />
      <div className="line" />
      <DeliveryStep
        label="8"
        infoLabel="Kontrakt og oppgjør"
        to="/leveransebeskrivelse-selge-bolig/kontrakt-og-oppgjor"
      />
      <div className="line" />
      <DeliveryStep
        label="9"
        infoLabel="Boligbytte"
        to="/leveransebeskrivelse-selge-bolig/boligbytte"
      />
      <div className="line" />
      <DeliveryStep
        label="10"
        infoLabel="Følger deg helt i mål"
        to="/leveransebeskrivelse-selge-bolig/overtakelse"
      />
      <div className="line" />
      <DeliveryStep
        label="11"
        infoLabel="Kjøp"
        to="/leveransebeskrivelse-selge-bolig/kjop"
      />
    </DeliveryDescriptionItemsWrapper>
  );
};

export const DeliverySteps: React.FC = () => {
  return (
    <StyledSectionContent>
      <DeliveryDescriptionWrapper />
    </StyledSectionContent>
  );
};
